import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import { useParams } from "react-router-dom";
import NavbarLoggedInNew from "components/Navbar-new/NavbarLoggedInNew";
import ErrorToast from "components/Toaster/ErrorToast";
import api from "../api";
import BatchWorkspaceSidebar from "./BatchWorkspaceSidebar";
import BatchModulesCard from "./BatchModulesCard";

const BatchWorkspace = () => {
  const { batchId } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [batchData, setBatchData] = useState(null);

  const fetchBatchWorkspace = useCallback(async () => {
    try {
      const response = await api.get(`batch/${batchId}/workspace/`);
      setBatchData(response.data);
    } catch (err) {
      setError("Failed to load batch workspace");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [batchId]);

  useEffect(() => {
    fetchBatchWorkspace();
  }, [fetchBatchWorkspace]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <>
        <ErrorToast message={error} />
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <Typography>{error}</Typography>
        </Box>
      </>
    );
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <NavbarLoggedInNew />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        p={2}
        pt={'30px'}
        sx={{
          px: { xs: 2, sm: 4, md: 8 },
          minHeight: 'calc(100vh - 64px)',
        }}
      >
        <Grid item xs={12} sm={4} md={3}>
          <BatchWorkspaceSidebar batchData={batchData} />
        </Grid>
        <Grid item xs={12} sm={8} md={9}>
          <BatchModulesCard batchData={batchData} onRefresh={fetchBatchWorkspace} />
        </Grid>
      </Grid>
    </>
  );
};

export default BatchWorkspace;
